import Task from "../../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import AssetLibrary from "../../assetloading/AssetLibrary";
import FontsConfig from "../model/FontsConfig";

export default class InitFontsTask extends Task {
    /**
     * 
     * @param {AssetLibrary} assetLibrary 
     * @param {FontsConfig} fontsConfig
     */
    constructor(assetLibrary, fontsConfig){
        super();
        this._assetLibrary = assetLibrary;
        this._fontsConfig = fontsConfig;
    }

    execute(callback){
        var fontsJson = this._assetLibrary.getAsset("fonts");
        this._fontsConfig.setPropertiesFromObject(fontsJson);
        callback(this);
    }
}